import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// EMPLOYEE APIS (FormData-based)
// Controller: Empcon.php
// ================================

// 1) Get Employees
export async function getEmployees(payload) {
  try {
    const fd = new FormData();

    fd.append("page_no", payload.page_no ?? 0);
    fd.append("keyword", payload.keyword || "");
    fd.append("role", payload.role || "");
    fd.append("status", payload.status || "");

    const res = await axios.post(`${apiBaseUrl}empcon/get_employees`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 2) Add Employee
export async function addEmployee(payload) {
  try {
    const fd = new FormData();

    fd.append("name", payload.name || "");
    fd.append("email", payload.email || "");
    fd.append("role", payload.role || "");
    fd.append("mobile", payload.mobile || "");
    fd.append("created_by", payload.created_by || "");

    const res = await axios.post(`${apiBaseUrl}empcon/add_employee`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 3) Update Employee
export async function updateEmployee(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");
    fd.append("name", payload.name || "");
    fd.append("email", payload.email || "");
    fd.append("role", payload.role || "");
    fd.append("mobile", payload.mobile || "");
    fd.append("updated_by", payload.updated_by || "");

    const res = await axios.post(`${apiBaseUrl}empcon/update_employee`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 4) Toggle Status
export async function toggleEmployeeStatus(user_id, status, updated_by = "") {
  try {
    const fd = new FormData();

    fd.append("user_id", user_id);
    fd.append("status", status);
    fd.append("updated_by", updated_by);

    const res = await axios.post(`${apiBaseUrl}empcon/toggle_employee_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 5) Delete Employee
export async function deleteEmployee(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}empcon/delete_employee`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 6) Reset Password
export async function resetEmployeePassword(user_id, updated_by = "") {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("updated_by", updated_by);

    const res = await axios.post(`${apiBaseUrl}empcon/reset_employee_password`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}
